<template>
    <div style="background: #fff;height:100%" class="title-wrapmain">
        <Headers :title="title"></Headers>
        <div class="item-wrap">
            <div class="info-item">
                <p class="info-title">{{ $t('personalCenter.name') }}</p>
                <el-input v-model="name" placeholder="" class="info-input"></el-input>
            </div>
            <div class="info-item">
                <p class="info-title" style="padding-bottom:18px">{{ $t('personalCenter.country') }}</p> 
                <el-select v-model="country" class="info-input">
                    <el-option v-for="item in countrys" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <!-- <div class="info-item">
                <p class="info-title">{{ $t('personalCenter.email') }}</p>
                <el-input v-model="email" disabled placeholder="" class="info-input"></el-input>
            </div> -->
            <div class="info-item">
                <p class="info-title">手机号</p>
                <el-input v-model="phone" placeholder="" disabled class="info-input"></el-input>
            </div>
            <div class="info-item" >
                <p class="info-title" style="padding-bottom:18px">{{ $t('personalCenter.interest')}}</p>
                <el-input  style="width:320px;" type="textarea" :autosize="{ minRows: 3, maxRows: 10}"  placeholder="" v-model="purpose"></el-input>
            </div>
            <div class="btn-wrap">
                <p class="save-btn" @click="handleSubmit">{{ $t('personalCenter.save') }}</p>
            </div>
        </div> 
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import { mapState } from "vuex";
import api from "@/api";


export default {
    name: 'mobilePersonalInfo',
    data() {
        return {
            countrys: [],
            country: "",
            name: "",
            company: "",
            purpose: "",
            phone: "",
            email: ""
        }
    },
    components: {
        Headers
    },
    created() {
        this.getCountry();
    },
    methods: {
        handleSubmit() {
            api.setUserInfo({
                real_name: this.name,
                country_code: this.country,
                company: this.company,
                purpose: this.purpose
            }).then((res) => {
                if (res.res === 1) {
                    this.$notify({type: 'success', message: res.mes });
                    this.$store.dispatch("getUserInfo");
                }
            });
        },
        getCountry() {
            api.getCountry().then((res) => {
                if (res.res === 1) {
                    const defaultLanguage = localStorage.getItem("language") || "zh";
                    this.countrys = res.country.map((item) => {
                        return {
                            value: item.code,
                            label: defaultLanguage === "zh" ? item.zh : item.en
                        };
                    });
                    console.log(this.countrys);
                }
            });
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  '基本资料' : 'Basic information'
        },
        ...mapState(["userInfo","language","showUserModal"]),
    },
    watch: {
        userInfo: {
            handler(userInfo) {
                if (userInfo) {
                    this.name = userInfo.real_name;
                    this.company = userInfo.company;
                    this.country = userInfo.country_code;
                    this.purpose = userInfo.purpose;
                    this.phone = userInfo.phone;
                    this.email = userInfo.email
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-input .el-input__inner{
    border-bottom: 1px solid #DCDFE6 !important;
    padding: unset;
    border: unset;
}
/deep/.el-input.is-disabled .el-input__inner{
    color:#333
}
/deep/.el-input.is-disabled .el-input__inner{
    background: unset;
}
.title-wrapmain{
    background-color: #fff;
//    >>>.el-tabs__item{
//         display: none;
//         font-size: 20px
//     }
    .item-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .info-item{
            display: flex;
            flex-direction: column;
            margin-top: 16px;
            width: 88%;
            .info-title{
                font-size: 14px;
                font-weight: 500; 
                margin: 16px 0 5px 0;
                color: #333333;
                width: 160px;
                padding-bottom: 4px;
            }
            // /deep/.el-input{
            //     background: none  !important;
            //     outline: none !important;
            //     border: none;
            //     border-radius: 0;
            //     border-bottom: 1px solid #D5D5D5 !important;
            //     padding: 0;
            // }
            // /deep/.el-input{
            //     text-align: left ;
            //     width: 320px
            // }
            // /deep/   .el-textarea{
            //     textarea{
            //         -webkit-appearance: none
            //     }
            // }
            .save-btn{
                width: 125px;
                margin-bottom: 28px
            }
                
        }
        .btn-wrap{
            margin-top: 2rem;
            display: flex;
            justify-content: center;
            .save-btn{
                color: #fff;
                font-size: 18px;
                width: 238px;
                height: 49px;
                line-height: 49px;
                text-align: center;
                // background: linear-gradient(180deg, #52B4DD 0%, #246DA8 100%);
                background: #194b96;
                border-radius: 24px
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilePersonalCenter/personalInfo.vue